import React, { useState } from "react";
import "./nav.css";
import {
  Nav,
  NavLink,
  Bars,
  NavMenu,
  NavBtn,
  NavBtnLink,
  NavLogoLink,
  NavBarExtended,
} from "./NavElement";
const navLinks = [
  { to: "/", label: "Home" },
  { to: "/About", label: "About" },
  { to: "/cars", label: "Cars" },
  { to: "/services", label: "Services" },
];
export default function Navbar() {
  const [extendNav, setExtendNav] = useState(false);
  return (
    <>
      <Nav extendNav={extendNav}>
        <NavLogoLink
          onClick={() => {
            setExtendNav((curr) => false);
          }}
          className="logo-nav"
          to="/"
        >
          <p className={`logo-nav ${extendNav ? "logo-open" : "logo-nav"}`}>
            E-WHEELS
          </p>
        </NavLogoLink>

        <Bars
          className="bars"
          onClick={() => {
            setExtendNav((curr) => !curr);
          }}
        />
        <NavMenu className="nav-menu">
          {navLinks.map((link) => (
            <NavLink className="NavLink nav-link" to={link.to} key={link.to}>
              {link.label}
            </NavLink>
          ))}
        </NavMenu>
        {extendNav && (
          <NavBarExtended>
            <NavLink
              onClick={() => {
                setExtendNav((curr) => !curr);
              }}
              className="NavLink nav-link"
              to="/"
            >
              Home
            </NavLink>
            <NavLink
              onClick={() => {
                setExtendNav((curr) => !curr);
              }}
              className="NavLink nav-link"
              to="/About"
            >
              About
            </NavLink>
            <NavLink
              onClick={() => {
                setExtendNav((curr) => !curr);
              }}
              className="NavLink nav-link"
              to="/cars"
            >
              Cars
            </NavLink>
            <NavLink
              onClick={() => {
                setExtendNav((curr) => !curr);
              }}
              className="NavLink nav-link"
              to="/services"
            >
              Services
            </NavLink>{" "}
            <NavLink
              onClick={() => {
                setExtendNav((curr) => !curr);
              }}
              className="NavLink nav-link"
              to="/contact"
            >
              Contact
            </NavLink>
          </NavBarExtended>
        )}
        <NavBtn>
          <NavBtnLink className="boton-nav" to="/contact">
            Contact Us
          </NavBtnLink>
        </NavBtn>
      </Nav>
    </>
  );
}
